import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const WorkoutSummaryModal = ({
  session,
  metrics,
  exercises,
  setLogs,
  onClose
}) => {
  const formatDuration = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    
    if (hours > 0) {
      return `${hours}h ${minutes}m ${secs}s`;
    }
    return `${minutes}m ${secs}s`;
  };

  const summaryStats = [
    {
      icon: 'CheckCircle',
      label: 'Exercises Completed',
      value: `${session?.completed_exercises}/${session?.total_exercises}`,
      color: 'var(--color-success)'
    },
    {
      icon: 'Layers',
      label: 'Total Sets',
      value: session?.completed_sets || 0,
      color: 'var(--color-primary)'
    },
    {
      icon: 'Clock',
      label: 'Duration',
      value: formatDuration(session?.total_duration_seconds || 0),
      color: 'var(--color-accent)'
    },
    {
      icon: 'TrendingUp',
      label: 'Total Volume',
      value: metrics?.total_volume ? `${Math.round(metrics?.total_volume)} lbs` : '-',
      color: 'var(--color-warning)'
    }
  ];

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card border border-border rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-success/20 flex items-center justify-center">
                <Icon name="Trophy" size={24} className="text-success" />
              </div>
              <div>
                <h2 className="text-2xl font-heading font-bold text-foreground">
                  Workout Complete!
                </h2>
                <p className="text-sm text-muted-foreground">
                  {session?.workout_name}
                </p>
              </div>
            </div>
            <Button
              variant="ghost"
              size="icon"
              onClick={onClose}
            >
              <Icon name="X" size={20} />
            </Button>
          </div>

          <div className="grid grid-cols-2 gap-4 mb-6">
            {summaryStats?.map((stat, index) => (
              <div 
                key={index}
                className="p-4 bg-muted rounded-lg"
              >
                <div className="flex items-center gap-2 mb-2">
                  <div 
                    className="w-8 h-8 rounded-lg flex items-center justify-center"
                    style={{ backgroundColor: `${stat?.color}15` }}
                  >
                    <Icon name={stat?.icon} size={16} color={stat?.color} strokeWidth={2} />
                  </div>
                  <p className="text-xs caption text-muted-foreground">{stat?.label}</p>
                </div>
                <p className="text-xl font-bold data-text text-foreground">
                  {stat?.value}
                </p>
              </div>
            ))}
          </div>

          {metrics && (
            <div className="mb-6 p-4 bg-primary/5 border border-primary/20 rounded-lg">
              <h3 className="text-lg font-heading font-semibold text-foreground mb-3">
                Performance Metrics
              </h3>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <p className="text-xs caption text-muted-foreground">Completion Rate</p>
                  <p className="text-lg font-bold data-text text-foreground">
                    {Math.round(metrics?.completion_percentage || 0)}%
                  </p>
                </div>
                <div>
                  <p className="text-xs caption text-muted-foreground">Avg Rest Time</p>
                  <p className="text-lg font-bold data-text text-foreground">
                    {metrics?.average_rest_time || 0}s
                  </p>
                </div>
              </div>
            </div>
          )}

          <div className="mb-6">
            <h3 className="text-lg font-heading font-semibold text-foreground mb-3">
              Exercise Breakdown
            </h3>
            <div className="space-y-2">
              {exercises?.map((exercise) => {
                const exerciseSets = setLogs?.filter(s => s?.exercise_log_id === exercise?.id) || [];
                return (
                  <div
                    key={exercise?.id}
                    className="p-3 bg-muted rounded-lg"
                  >
                    <div className="flex items-center justify-between mb-2">
                      <p className="font-medium text-foreground">{exercise?.exercise_name}</p>
                      <span className={`text-xs px-2 py-1 rounded-full ${
                        exercise?.status === 'completed' 
                          ? 'bg-success/20 text-success'
                          : exercise?.status === 'skipped' ?'bg-warning/20 text-warning' :'bg-muted-foreground/20 text-muted-foreground'
                      }`}>
                        {exercise?.status}
                      </span>
                    </div>
                    <p className="text-sm text-muted-foreground">
                      {exerciseSets?.length} sets completed
                    </p>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="flex gap-3">
            <Button
              onClick={onClose}
              className="flex-1"
              size="lg"
              iconName="Home"
            >
              Back to Dashboard
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkoutSummaryModal;